import {Button, Div, ImageView, Label, Toast} from 'components';
import {Ecolors, Icons} from 'constant';
import React, {useRef, useState} from 'react';
import {ActivityIndicator, View} from 'react-native';
import QQ from 'react-native-qrcode-svg';
import {downloadQRCode, widthScale} from 'utils';

function QREventLink(props: {eventLink: string}) {
  const [loading, setLoading] = useState<boolean>(false);

  const onSaveQRCode = async () => {
    if (loading) {
      return;
    }
    setLoading(true);
    try {
      await downloadQRCode('viewshotRefEvent');
      Toast.show({
        content: 'alert.taithanhcong',
        multilanguage: true,
      });
    } catch (error) {
    } finally {
      setLoading(false);
      Toast.show({
        content: 'alert.daxayraloi',
        multilanguage: true,
      });
    }
  };

  return (
    <Div
      flexDirection={'row'}
      marginVertical={12}
      alignItems={'center'}
      justifyContent={'space-between'}>
      <View nativeID="viewshotRefEvent">
        <Div borderRadius={8} backgroundColor={Ecolors.bgtime} padding={7}>
          <QQ
            size={widthScale(125)}
            backgroundColor={Ecolors.whiteColor}
            value={props?.eventLink || '1231'}
          />
        </Div>
      </View>

      <Div flex={1} alignItems="center">
        <Label size={14}>{`eventreward.maqrgioithieu`}</Label>
        <Button
          widthHeight={100}
          justifyContent={'center'}
          onPress={onSaveQRCode}
          alignItems={'center'}>
          {loading ? (
            <ActivityIndicator size={'large'} color={Ecolors.mainColor} />
          ) : (
            <>
              <ImageView
                width={30}
                height={23}
                resizeMode={'contain'}
                source={Icons.downloadqr}
              />
              <Label marginTop={6}>{`eventreward.taive`}</Label>
            </>
          )}
        </Button>
      </Div>
    </Div>
  );
}

export default React.memo(QREventLink);
